export class ParseError extends Error {
  constructor(message?: string) {
    super(`데이터 변환중 오류가 발생하였습니다.<br/>${message}`);
  }
}
